// Added by Sejune Oh on 2020-02-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC, forwardRef } from 'react';
import {
    MenuItem as MaterialMenuItem,
    MenuItemProps as MaterialMenuItemProps
} from '@material-ui/core'

// Common props
interface MenuItemBaseProps { }
export type MenuItemProps = Partial<MaterialMenuItemProps> & MenuItemBaseProps

export const MenuItem: FC<MenuItemProps> = forwardRef(({ ...props }, ref) => {
    return <MaterialMenuItem {...props} ref={ref} button />
})
